import React from 'react';
import { useTranslation } from 'react-i18next';
import LockIcon from '@wix/da-ds/pkg/Icons/16x16/Lock';

import s from './ShippingInformationCard.scss';

const SHIPPING_FIELDS = [
  'country',
  'contactNumber',
  'address',
  'fullName',
  'city',
  'stateProvince',
  'zipPostalCode',
] as const;

const ShippingInformationCard: React.FC<{}> = () => {
  const { t } = useTranslation();
  return (
    <div className={s['root']}>
      <div className={s['header']}>
        <span className={s['required-badge']}>
          {t('artsAndCraftsDeviationPopup.questionnaire.shipping.required')}
        </span>
        <LockIcon className={s['lock-icon']} />
      </div>
      <h3 className={s['title']}>
        {t('artsAndCraftsDeviationPopup.questionnaire.shipping.title')}
      </h3>
      <p className={s['description']}>
        {t('artsAndCraftsDeviationPopup.questionnaire.shipping.description')}
      </p>
      <p className={s['fields-label']}>
        {t('artsAndCraftsDeviationPopup.questionnaire.shipping.fieldsLabel')}
      </p>
      <div className={s['fields']}>
        {SHIPPING_FIELDS.map(field => (
          <span key={field} className={s['field-tag']}>
            {t(`artsAndCraftsDeviationPopup.questionnaire.shipping.field.${field}`)}
          </span>
        ))}
      </div>
    </div>
  );
};
ShippingInformationCard.displayName = 'ShippingInformationCard';

export default ShippingInformationCard;
